'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Scopes } from '../../lib/Scopes';
import ScopeWrapper from '../ScopeWrapper';
export const EditColumnsButton = ({
  onClick
}) => /*#__PURE__*/_jsx(ScopeWrapper, {
  tooltipKey: "editColumns",
  orScopes: [Scopes.ADS_WRITE, Scopes.ADS_DEMO_ACCESS],
  children: /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "edit-columns",
    use: "transparent",
    onClick: onClick,
    children: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "editColumns",
        size: "xxs",
        className: "m-right-1"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.addMetrics"
      })]
    })
  })
});
EditColumnsButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default EditColumnsButton;